<!-- (老的，临时用) -->
<template>
  <!-- 活动-眉笔活动-眉笔活动管理-奖品配置弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="配置奖品"
      width="850px"
      @close="closeConfigDialog"
    >
      <div v-loading="dialogLoading">
      <p
        class="text-line"
        style="margin-bottom: 10px"
        v-for="(item, index) in remarks"
        :key="index"
      >
        排名区间：
        <el-input
          style="width: 140px"
          placeholder="请输入排名"
          v-model="item.min_level"
        ></el-input>
        —
        <el-input
          style="width: 140px; margin-right: 10px"
          placeholder="请输入排名"
          v-model="item.max_level"
        ></el-input>
        <el-select
          style="width: 140px; margin-right: 10px"
          v-model="item.type"
          placeholder="请选择类型"
        >
          <el-option :value="1" label="钻石"></el-option>
          <el-option :value="2" label="商城币"></el-option>
        </el-select>
        <el-input
          style="width: 140px; margin-right: 10px"
          placeholder="请输入金额"
          v-model="item.reward_money"
        ></el-input>
        <i
          v-if="remarks.length > 1"
          class="el-icon-remove-outline"
          style="
            font-size: 20px;
            color: #f56c6c;
            margin-left: 20px;
            cursor: pointer;
          "
          @click="reduceTextLine(index)"
        ></i>
        <i
          v-if="remarks.length - 1 === index"
          class="el-icon-circle-plus-outline"
          style="
            font-size: 20px;
            color: #409eff;
            margin-left: 20px;
            cursor: pointer;
          "
          @click="addTextLine"
        ></i>
      </p>
      <p class="btn-box">
        <el-button style="margin-right: 20px" @click="closeConfigDialog"
          >取消</el-button
        >
        <el-button type="primary" @click="submit" :loading="buttonLoading"
          >确定</el-button
        >
      </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
export default {
  components: {},
  props: {
    value: {
      type: Number,
      default: 1
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogLoading: false,//弹窗加载动画
      buttonLoading: false,//按钮加载动画
      remarks: [{ min_level: 0, max_level: 0, type: 1, reward_money: 0 }],//设置弹窗初始数据
    }
  },
  computed: {
    dialogVisible: {//显示标志
      get() {
        return this.visible
      },
      set() { }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getData()
      }
    }
  },
  created() {
  },
  methods: {
    getData() {
      //获取表单数据
      this.dialogLoading = true
      getApiData(`brow_reward`).then(res => {
        if (res) {
          if (res.length) {
            this.remarks = res
          }

          //按金额进行从小到大排序
          for (let i = 0; i < this.remarks.length - 1; i++) {
            for (let j = 0; j < this.remarks.length - 1 - i; j++) {
              if (this.remarks[j].min_level > this.remarks[j + 1]
                .min_level) {
                let temp = this.remarks[j];
                this.remarks[j] = this.remarks[j + 1];
                this.remarks[j + 1] = temp;
              }
            }
          }
        }
      }).finally(() => {
        this.dialogLoading = false
      })
    },
    addTextLine() {
      //加行
      let params = { min_level: 0, max_level: 0, type: 1, reward_money: 0 }
      this.remarks.push(params)
    },
    reduceTextLine(num) {
      //减行
      this.remarks.splice(num, 1)
    },
    submit() {
      //保存编辑好的表单信息
      this.buttonLoading = true

      //检测最大值不能小于最小值
      let testArr = []
      for (let i = 0, len = this.remarks.length; i < len; i++) {
        testArr.push(this.remarks[i].min_level)
        testArr.push(this.remarks[i].max_level)
        if (this.remarks[i] && (parseFloat(this.remarks[i].min_level) > parseFloat(this.remarks[i].max_level))) {
          this.$message.error(`第${i + 1}行，前一排名不能大于后一排名`)
          this.buttonLoading = false
          return
        }

        if (this.remarks[i] && this.remarks[i].reward_money <= 0) {
          this.$message.error(`第${i + 1}行，金额必须大于0`)
          this.buttonLoading = false
          return
        }

        if (this.remarks[i] && (!this.remarks[i].min_level) || !this.remarks[i].max_level || !this.remarks[i].type || !this.remarks[i].reward_money) {
          this.$message.error(`第${i + 1}行，数据不能为空`)
          this.buttonLoading = false
          return
        }
      }

      for (let j = 0; j < testArr.length - 3; j = j + 2) {
        if (Number(testArr[j + 2]) <= Number(testArr[j + 1])) {
          this.$message.error(`排名区间有重叠`)
          this.buttonLoading = false
          return
        }
      }

      let params

      if (this.remarks.length === 1) {
        if ((!this.remarks[0].min_level || this.remarks[0].min_level == 0) && (!this.remarks[0].max_level || this.remarks[0].max_level == 0)) {
          params = { remarks: '' };
        } else {
          params = {
            remarks: this.remarks
          }
        }
      } else {
        params = {
          remarks: this.remarks
        }
      }

      patchApiData('brow_reward', params)
        .then(res => {
          this.$message.success("保存成功！")
          this.closeConfigDialog()//关闭弹窗
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    closeConfigDialog() {
      //关闭弹窗
      this.$emit('close')
    },
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>